/**
 * Mirrors mobile businessOnboardingTypes.isFullyOnboardedBusiness.
 * Phone sign-in users may have owner_no instead of email.
 */
export function isFullyOnboardedBusiness(biz) {
  const businessName = (biz?.name || biz?.display_name || '').trim();
  const contact = (biz?.email || biz?.owner_no || biz?.phone || '').trim();
  return !!businessName && !!contact;
}

/** Drop wallet-only stubs so BusinessSetup runs before /app. */
export function normalizeRegisteredBusiness(data, fallbackId) {
  if (!data) return null;
  const business_id = data.business_id || data.id || fallbackId || null;
  if (!business_id) return null;
  if (!isFullyOnboardedBusiness(data)) return null;
  return {
    ...data,
    id: business_id,
    business_id,
    settings: data.settings || {
      basePrompt: '',
      welcomeMessage: '',
      primaryColor: '#2563EB',
    },
  };
}
